/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

document.addEventListener("click", function(e) {
  if (e.target.matches(".btn-add")) {
    e.preventDefault();
    e.stopPropagation();
    
    // Add item to cart without redirecting
    // User can continue shopping or click cart to proceed to checkout
    let el = e.target;
    let originalText = el.innerText;
    el.innerText = "Adding...";
    el.disabled = true;

    let xhr = new XMLHttpRequest();
    xhr.open("POST", "/cart/add.js", true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 400) {
        // Success - update button and show feedback
        el.innerText = "Added ✓";
        el.style.background = "#2e7d32";
        
        // Update cart count in header
        updateCartCount();
        
        // Show toast notification (especially helpful on mobile)
        showAddedToast();
        
        // Reset button after 2 seconds
        setTimeout(function() {
          el.innerText = originalText;
          el.style.background = "";
          el.disabled = false;
        }, 2000);
      } else {
        alert("Could not add to cart. Please try again.");
        el.innerText = originalText;
        el.disabled = false;
      }
    };
    xhr.onerror = function () {
      alert("Connection error. Please try again.");
      el.innerText = originalText;
      el.disabled = false;
    };
    xhr.send(JSON.stringify({
      id: el.dataset.variant,
      quantity: 1
    }));
  }

  if (e.target.matches(".remove-item-from-cart")) {
    e.preventDefault();
    e.stopPropagation();
    let el = e.target;
    el.innerText = "Removing...";
    addClass(el, "processing");
    let xhr = new XMLHttpRequest();
    xhr.open("POST", "/cart/update.js", true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 400) {
        location.reload();
      } else {
        alert("Unexpected server error. Please try again");
      }
    };
    xhr.onerror = function() {
      alert("Unexpected connection error. Please try again");
    };
    xhr.send("updates[" + el.dataset.variantId + "]=0");
  }
}, false);

// Update cart count in header
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Update cart count text
      const cartCountElements = document.querySelectorAll('.Header__CartCount, .cart-count, [data-cart-count]');
      cartCountElements.forEach(el => {
        el.textContent = cart.item_count;
      });
      
      // Show/hide the cart dot indicator
      const cartDotElements = document.querySelectorAll('.Header__CartDot');
      cartDotElements.forEach(el => {
        if (cart.item_count > 0) {
          el.classList.add('is-visible');
        } else {
          el.classList.remove('is-visible');
        }
      });
      
      // Animate the cart icon to draw attention
      const cartIcons = document.querySelectorAll('.Header__CartIcon, [class*="cart-icon"]');
      cartIcons.forEach(icon => {
        icon.style.transform = 'scale(1.3)';
        setTimeout(() => {
          icon.style.transform = '';
        }, 200);
      });
    })
    .catch(err => console.log('Could not update cart count'));
}

// Show toast notification for add to cart
function showAddedToast() {
  // Remove existing toast if any
  const existingToast = document.querySelector('.cart-toast');
  if (existingToast) existingToast.remove();
  
  // Create toast element
  const toast = document.createElement('div');
  toast.className = 'cart-toast';
  toast.innerHTML = `
    <div class="cart-toast__content">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
      <span>Added to cart!</span>
      <a href="/pages/form" class="cart-toast__btn">View Cart</a>
    </div>
  `;
  document.body.appendChild(toast);
  
  // Animate in
  setTimeout(() => toast.classList.add('is-visible'), 10);
  
  // Remove after 4 seconds
  setTimeout(() => {
    toast.classList.remove('is-visible');
    setTimeout(() => toast.remove(), 300);
  }, 4000);
}

// Inject toast styles
(function() {
  const style = document.createElement('style');
  style.textContent = `
    .cart-toast {
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%) translateY(100px);
      z-index: 9999;
      opacity: 0;
      transition: transform 0.3s ease, opacity 0.3s ease;
    }
    .cart-toast.is-visible {
      transform: translateX(-50%) translateY(0);
      opacity: 1;
    }
    .cart-toast__content {
      display: flex;
      align-items: center;
      gap: 10px;
      background: #222;
      color: #fff;
      padding: 14px 20px;
      border-radius: 50px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.25);
      font-size: 14px;
      font-weight: 500;
    }
    .cart-toast__content svg {
      color: #4caf50;
      flex-shrink: 0;
    }
    .cart-toast__btn {
      background: #ff7a20;
      color: #fff !important;
      padding: 8px 16px;
      border-radius: 20px;
      text-decoration: none !important;
      font-weight: 600;
      font-size: 13px;
      margin-left: 5px;
      white-space: nowrap;
    }
    .cart-toast__btn:hover {
      background: #e86a10;
    }
    @media (max-width: 480px) {
      .cart-toast {
        bottom: 15px;
        left: 15px;
        right: 15px;
        transform: translateX(0) translateY(100px);
      }
      .cart-toast.is-visible {
        transform: translateX(0) translateY(0);
      }
      .cart-toast__content {
        justify-content: center;
      }
    }
  `;
  document.head.appendChild(style);
})();

function addClass(el, className) {
  if (el.classList)
    el.classList.add(className);
  else
    el.className += ' ' + className;
}

// ============================================
// THANK YOU OVERLAY - Form Submission Success
// ============================================
window.showThankYouOverlay = function(customerEmail) {
  // Create overlay container
  var overlay = document.createElement('div');
  overlay.id = 'thank-you-overlay';
  overlay.innerHTML = `
    <div class="tyo-backdrop"></div>
    <div class="tyo-card">
      <div class="tyo-checkmark">
        <svg viewBox="0 0 52 52">
          <circle class="tyo-checkmark-circle" cx="26" cy="26" r="24"/>
          <path class="tyo-checkmark-check" d="M14 27l8 8 16-16"/>
        </svg>
      </div>
      <h1 class="tyo-heading">Thank You!</h1>
      <p class="tyo-subheading">Your layby application has been submitted successfully</p>
      
      <div class="tyo-email-box">
        <div class="tyo-email-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="2" y="4" width="20" height="16" rx="2"/>
            <path d="M22 6l-10 7L2 6"/>
          </svg>
        </div>
        <h3>Check Your Email</h3>
        <p>We've sent your Layby Agreement and order details to:</p>
        <p class="tyo-email-address">${customerEmail || 'your email'}</p>
        <p class="tyo-email-note">Please keep this for your records.</p>
      </div>
      
      <div class="tyo-steps">
        <h4>What's Next?</h4>
        <ol>
          <li>We've sent your layby agreement and order details 📧</li>
          <li>Review and keep the agreement for your records</li>
          <li>We'll be in touch to get you started! ✨</li>
        </ol>
      </div>
      
      <a href="/collections/all" class="tyo-button">Continue Shopping</a>
      
      <p class="tyo-footer">Questions? Contact us at <a href="mailto:contact@lafurniture.com.au">contact@lafurniture.com.au</a></p>
    </div>
  `;
  
  document.body.appendChild(overlay);
  
  // Prevent body scroll
  document.body.style.overflow = 'hidden';
  
  // Trigger animations after a tiny delay
  requestAnimationFrame(function() {
    overlay.classList.add('tyo-visible');
  });
};

// Inject Thank You Overlay Styles
(function() {
  var tyoStyles = document.createElement('style');
  tyoStyles.textContent = `
    #thank-you-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 999999;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      opacity: 0;
      transition: opacity 0.4s ease;
    }
    #thank-you-overlay.tyo-visible {
      opacity: 1;
    }
    
    /* Backdrop */
    .tyo-backdrop {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.85);
    }
    
    /* Confetti */
    .tyo-confetti {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: hidden;
      pointer-events: none;
    }
    .tyo-confetti-piece {
      position: absolute;
      width: 10px;
      height: 10px;
      top: -20px;
      left: calc(var(--i) * 2%);
      background: hsl(calc(var(--i) * 7), 80%, 60%);
      opacity: 0;
      transform: rotate(0deg);
    }
    #thank-you-overlay.tyo-visible .tyo-confetti-piece {
      animation: confetti-fall 3s ease-out forwards;
      animation-delay: calc(var(--i) * 0.02s);
    }
    @keyframes confetti-fall {
      0% {
        opacity: 1;
        top: -20px;
        transform: rotate(0deg) scale(1);
      }
      100% {
        opacity: 0;
        top: 100%;
        transform: rotate(720deg) scale(0.5);
      }
    }
    
    /* Card */
    .tyo-card {
      position: relative;
      background: #ffffff;
      border-radius: 20px;
      padding: 50px 40px;
      max-width: 480px;
      width: 100%;
      text-align: center;
      box-shadow: 0 25px 80px rgba(0, 0, 0, 0.4);
      transform: translateY(30px) scale(0.95);
      opacity: 0;
      transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
      max-height: 90vh;
      overflow-y: auto;
    }
    #thank-you-overlay.tyo-visible .tyo-card {
      transform: translateY(0) scale(1);
      opacity: 1;
      transition-delay: 0.1s;
    }
    
    /* Checkmark */
    .tyo-checkmark {
      width: 80px;
      height: 80px;
      margin: 0 auto 25px;
    }
    .tyo-checkmark svg {
      width: 100%;
      height: 100%;
    }
    .tyo-checkmark-circle {
      fill: none;
      stroke: #c44503;
      stroke-width: 2;
      stroke-dasharray: 150;
      stroke-dashoffset: 150;
      transform-origin: center;
    }
    #thank-you-overlay.tyo-visible .tyo-checkmark-circle {
      animation: checkmark-circle 0.6s ease-out forwards;
      animation-delay: 0.3s;
    }
    @keyframes checkmark-circle {
      to { stroke-dashoffset: 0; }
    }
    .tyo-checkmark-check {
      fill: none;
      stroke: #c44503;
      stroke-width: 3;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-dasharray: 50;
      stroke-dashoffset: 50;
    }
    #thank-you-overlay.tyo-visible .tyo-checkmark-check {
      animation: checkmark-check 0.4s ease-out forwards;
      animation-delay: 0.7s;
    }
    @keyframes checkmark-check {
      to { stroke-dashoffset: 0; }
    }
    
    /* Typography */
    .tyo-heading {
      font-size: 36px;
      font-weight: 700;
      color: #1a1a1a;
      margin: 0 0 8px;
      opacity: 0;
      transform: translateY(10px);
    }
    #thank-you-overlay.tyo-visible .tyo-heading {
      animation: fadeInUp 0.4s ease forwards;
      animation-delay: 0.5s;
    }
    .tyo-subheading {
      font-size: 16px;
      color: #666;
      margin: 0 0 30px;
      opacity: 0;
      transform: translateY(10px);
    }
    #thank-you-overlay.tyo-visible .tyo-subheading {
      animation: fadeInUp 0.4s ease forwards;
      animation-delay: 0.6s;
    }
    @keyframes fadeInUp {
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    /* Email Box */
    .tyo-email-box {
      background: linear-gradient(135deg, #fff5f0 0%, #fff 100%);
      border: 2px solid #ffe0d0;
      border-radius: 16px;
      padding: 25px 20px;
      margin-bottom: 25px;
      opacity: 0;
      transform: translateY(10px);
    }
    #thank-you-overlay.tyo-visible .tyo-email-box {
      animation: fadeInUp 0.4s ease forwards;
      animation-delay: 0.7s;
    }
    .tyo-email-icon {
      width: 50px;
      height: 50px;
      margin: 0 auto 15px;
      background: #c44503;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .tyo-email-icon svg {
      width: 24px;
      height: 24px;
      color: #fff;
    }
    .tyo-email-box h3 {
      font-size: 18px;
      font-weight: 700;
      color: #1a1a1a;
      margin: 0 0 10px;
    }
    .tyo-email-box p {
      font-size: 14px;
      color: #555;
      margin: 0 0 5px;
    }
    .tyo-email-address {
      font-weight: 700;
      color: #c44503 !important;
      font-size: 15px !important;
      word-break: break-all;
    }
    .tyo-email-note {
      font-size: 13px !important;
      color: #888 !important;
      margin-top: 10px !important;
    }
    
    /* Steps */
    .tyo-steps {
      text-align: left;
      margin-bottom: 30px;
      opacity: 0;
      transform: translateY(10px);
    }
    #thank-you-overlay.tyo-visible .tyo-steps {
      animation: fadeInUp 0.4s ease forwards;
      animation-delay: 0.8s;
    }
    .tyo-steps h4 {
      font-size: 16px;
      font-weight: 700;
      color: #1a1a1a;
      margin: 0 0 15px;
      text-align: center;
    }
    .tyo-steps ol {
      margin: 0;
      padding: 0 0 0 25px;
    }
    .tyo-steps li {
      font-size: 14px;
      color: #555;
      padding: 6px 0;
      line-height: 1.5;
    }
    .tyo-steps li::marker {
      color: #c44503;
      font-weight: 700;
    }
    
    /* Button */
    .tyo-button {
      display: inline-block;
      background: #c44503;
      color: #fff !important;
      font-size: 15px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      padding: 16px 40px;
      border-radius: 8px;
      text-decoration: none !important;
      transition: all 0.3s ease;
      opacity: 0;
      transform: translateY(10px);
    }
    #thank-you-overlay.tyo-visible .tyo-button {
      animation: fadeInUp 0.4s ease forwards;
      animation-delay: 0.9s;
    }
    .tyo-button:hover {
      background: #a33a02;
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(196, 69, 3, 0.3);
    }
    
    /* Footer */
    .tyo-footer {
      font-size: 13px;
      color: #888;
      margin: 25px 0 0;
      opacity: 0;
    }
    #thank-you-overlay.tyo-visible .tyo-footer {
      animation: fadeInUp 0.4s ease forwards;
      animation-delay: 1s;
    }
    .tyo-footer a {
      color: #c44503;
      text-decoration: none;
    }
    .tyo-footer a:hover {
      text-decoration: underline;
    }
    
    /* Mobile adjustments */
    @media (max-width: 520px) {
      .tyo-card {
        padding: 40px 25px;
        border-radius: 16px;
      }
      .tyo-heading {
        font-size: 28px;
      }
      .tyo-checkmark {
        width: 65px;
        height: 65px;
      }
      .tyo-button {
        width: 100%;
        padding: 14px 30px;
      }
    }
  `;
  document.head.appendChild(tyoStyles);
})();